<div class="gs-modal">
  <!-- the game, front and centre -->
  <header class="gs-hero">
    <button type="button" class="gs-token" (click)="uploadPartyToken(game_details)" title="Change the party token"
      aria-label="Change the party token">
      <img [src]="partyToken || 'assets/images/ac-token-game.png'" alt="" />
      <span class="gs-token-edit" aria-hidden="true">
        <img src="assets/icons/icon-upload-outline.svg" alt="" />
      </span>
    </button>
    <div class="gs-hero-text">
      <span class="gs-eyebrow">Ready to play</span>
      <h4>{{ game_details?.Gamename || 'Your game' }}</h4>
      <p>{{ game_details?.game_system || 'No game system' }} · Map: {{ game_details?.map_name || '—' }}</p>
    </div>
    <button type="button" class="gs-close" (click)="closeModal()" aria-label="Close">
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" aria-hidden="true">
        <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      </svg>
    </button>
  </header>

  <div class="gs-body">
    <!-- the table: one circle per seat -->
    <div class="gs-section-head">
      <h5>Party</h5>
      <span class="gs-count">{{ seatedCount }} of {{ acceptedChar_details?.length || 0 }} seated</span>
    </div>
    <div class="gs-seats">
      @for (char of acceptedChar_details; track $index; let i = $index) {
        @if (char.character_id) {
          <span class="gs-seat is-taken" [title]="char.nickname + ' ' + (char.last_name || '')">{{ initials(char) }}</span>
        } @else {
          <span class="gs-seat" [title]="'Seat ' + (i + 1) + ' is open'">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true">
              <path d="M12 6v12M6 12h12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
            </svg>
          </span>
        }
      }
    </div>

    <!-- who is seated (tick to remove) -->
    @if (seatedCount > 0) {
      <div class="wt-seat-list">
        @for (char of acceptedChar_details; track $index) {
          @if (char.character_id) {
            <label class="wt-seat">
              <input type="checkbox" [checked]="listofRemoveCharacters.includes(char.character_id)"
                (change)="onPlayerRemoveTick(char)" [attr.aria-label]="'Select ' + char.nickname" />
              <span class="wt-seat-main">
                <span class="wt-seat-name">{{ char.nickname }} {{ char.last_name }}</span>
                <span class="wt-seat-meta">@if (char.user_name) {{{ char.user_name }} · }Level {{ char.primary_class_level }} {{ char.primary_class }}</span>
              </span>
            </label>
          }
        }
      </div>
      <div class="gs-roster-actions">
        <button type="button" class="btn btn-outline btn-sm" (click)="openCharacterDeleteConfirmModal(false)"
          [disabled]="listofRemoveCharacters.length === 0">Remove selected</button>
      </div>
    } @else {
      <p class="gs-hint">No one is seated yet — invite players from
        <button type="button" class="gs-link" (click)="handleDetailClick()">Game details</button>.</p>
    }

    <!-- handouts -->
    <div class="gs-guides">
      <button type="button" class="gs-guide" (click)="downloadGmGuide()">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true">
          <path d="M12 4v11m0 0l-4.5-4.5M12 15l4.5-4.5M5 19h14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        GM Guide
      </button>
      <button type="button" class="gs-guide" (click)="downloadPlayerGuide()">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true">
          <path d="M12 4v11m0 0l-4.5-4.5M12 15l4.5-4.5M5 19h14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        Player Guide
      </button>
    </div>
  </div>

  <footer class="gs-foot">
    <button type="button" class="gs-link" (click)="handleDetailClick()">Game details ›</button>
    <div class="gs-foot-right">
      <button type="button" class="btn btn-outline" (click)="closeModal()">Cancel</button>
      <button type="button" class="btn btn-green gs-play" (click)="handlePlayClick()">
        <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M7 4.5v15l12.5-7.5L7 4.5z" fill="currentColor" /></svg>
        Play
      </button>
    </div>
  </footer>
</div>
